import { ConfigurationPreviewCard } from '@framework/ui/components/configuration-card/ConfigurationPreviewCard.tsx';
import { useId } from 'react';
import styled from 'styled-components';
import {
  DEFAULT_FILL,
  DEFAULT_STROKE,
  PreviewContainer,
} from './mapStylePreviewShared.ts';

export interface IMapShapeStylePreviewProps {
  fillColor?: string;
  strokeColor?: string;
  strokeWidth?: number;
  /** Opacità del riempimento (0-1). */
  fillOpacity?: number;
  /** Opacità del bordo (0-1). */
  strokeOpacity?: number;
}

// Triangolo su cui applicare lo stile.
const SHAPE_POINTS = '160,24 252,100 68,100';

// Scacchiera di trasparenza (stile editor grafici) per rendere percepibile
// l'opacità del riempimento e del bordo.
const CHECKER_TILE = 14;
const CHECKER_LIGHT = '#ffffff';
const CHECKER_DARK = '#d9d9d9';

const PreviewFrame = styled.div`
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  line-height: 0;
  border: 1px solid ${props => props.theme.colorSplit};
`;

/**
 * Anteprima grafica di una geometria con lo stile configurato (colore di
 * riempimento, colore e spessore del bordo, opacità) sovrapposta a una
 * scacchiera di trasparenza, così da rendere percepibile l'effetto
 * dell'opacità.
 */
export function MapShapeStylePreview(props: IMapShapeStylePreviewProps) {
  const {
    fillColor = DEFAULT_FILL,
    strokeColor = DEFAULT_STROKE,
    strokeWidth = 2,
    fillOpacity = 1,
    strokeOpacity = 1,
  } = props;

  // Id univoco per il pattern: l'anteprima può comparire più volte nella pagina.
  const checkerId = `map-shape-checker-${useId().replace(/[^a-zA-Z0-9]/g, '')}`;

  return (
    <PreviewContainer>
      <ConfigurationPreviewCard>
        <PreviewFrame>
          <svg
            viewBox="0 0 320 120"
            style={{ width: '100%', height: 'auto', display: 'block' }}
            role="img"
            aria-label="Anteprima dello stile della geometria"
          >
            <defs>
              <pattern
                id={checkerId}
                width={CHECKER_TILE}
                height={CHECKER_TILE}
                patternUnits="userSpaceOnUse"
              >
                <rect
                  width={CHECKER_TILE}
                  height={CHECKER_TILE}
                  fill={CHECKER_LIGHT}
                />
                <rect
                  width={CHECKER_TILE / 2}
                  height={CHECKER_TILE / 2}
                  fill={CHECKER_DARK}
                />
                <rect
                  x={CHECKER_TILE / 2}
                  y={CHECKER_TILE / 2}
                  width={CHECKER_TILE / 2}
                  height={CHECKER_TILE / 2}
                  fill={CHECKER_DARK}
                />
              </pattern>
            </defs>

            {/* Scacchiera di trasparenza */}
            <rect width="320" height="120" fill={`url(#${checkerId})`} />

            {/* Geometria con lo stile configurato */}
            <polygon
              points={SHAPE_POINTS}
              fill={fillColor}
              fillOpacity={fillOpacity}
              stroke={strokeColor}
              strokeWidth={strokeWidth}
              strokeOpacity={strokeOpacity}
              strokeLinejoin="round"
            />
          </svg>
        </PreviewFrame>
      </ConfigurationPreviewCard>
    </PreviewContainer>
  );
}
